import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'
import { getCurrentTimestamp } from '../utils/timestamp.util'
import {
  deleteAPICallServer,
  getAPICallServer,
  postAPICallServer,
} from '../utils/axios.util'
import { apiServerRoutes } from '../constants/apiRoutes'
import { getAuthUserId } from '../utils/auth.util'

class ImageService {
  /**
   *
   * @param files list of all files
   * @param slug unique key to group the uploaded images
   */
  async UploadImageToStorage(files: any, storePath: string) {
    // for (let index = 0; index < files.length; index++) {
      const element = files[0]
      const storage = getStorage()
      const path: string =
        `images/${getAuthUserId() ?? 'USER_UNDEFINED'}/${storePath}` ??
        getCurrentTimestamp()
      const storageRef = ref(storage, path)

      // console.log(path, storePath)
      try {
        const resp = await uploadBytes(storageRef, element)
        const previewUrl = await getDownloadURL(storageRef)
        const { metadata } = resp
        return {
          bucket: metadata.bucket,
          full_path: metadata.fullPath,
          name: metadata.name,
          size: metadata.size,
          content_type: metadata.contentType,
          preview_url: previewUrl,
        }
      } catch (e: any) {
        throw new Error(e.message)
      }
    // }
  }

  async saveImage(req: any) {
    return postAPICallServer(apiServerRoutes.SAVE_IMAGES, req, req)
  }

  async getImage(req: any) {
    const { id } = req.body
    return getAPICallServer(apiServerRoutes.GET_IMAGES.replace(':id', id), req)
  }

  async removeImage(req: any) {
    const { id } = req.body
    return deleteAPICallServer(
      apiServerRoutes.REMOVE_IMAGE.replace(':id', id),
      req,
    )
  }
}

export default new ImageService()
